import styled from 'styled-components';
import { palette } from 'styled-theme';
import colors from '../../theme/colors';

const TouchableOpacity = styled('button')`
  display: inline-block;
  margin: 0 20px;
  cursor: pointer;
  border: 0;
  outline: 0;
  background-color: transparent;
  transition: color 0.2s ease-in;
  &:hover {
    color: ${colors.primary};
  }
`;

const MenuText = styled('span')`
  color: ${props =>
    props.menuTextColor ? props.menuTextColor : palette('text', 2)};
  font-size: ${props => (props.menuTextSize ? props.menuTextSize : 16)}px;
  line-height: ${props =>
    props.menuTextLineHeight ? props.menuTextLineHeight : 19}px;
  text-transform: capitalize;
  font-family: Poppins, Sans Serif;
  font-weight: 500;
  &:hover,
  &.active {
    color: ${colors.primary};
    &:after {
      width: 30px;
    }
  }
  &:after {
    content: ' ';
    display: block;
    background-color: ${colors.primary};
    height: 3px;
    border-radius: 1.5px;
    margin-top: 5px;
    position: absolute;
    width: 0px;
    transition: width 0.2s ease-in;
  }
`;

const CountText = styled('span')`
  color: ${props =>
    props.countTextColor ? props.countTextColor : palette('text', 1)};
  font-size: ${props => (props.countTextSize ? props.countTextSize : 16)}px;
  line-height: ${props =>
    props.countTextLineHeight ? props.countTextLineHeight : 19}px;
  text-transform: capitalize;
  font-weight: 500;
  margin-left: 10px;
  pointer-events: none;
  &:hover {
    color: ${colors.primary};
  }
  &.active {
    color: ${colors.primary};
  }
`;

export { TouchableOpacity, MenuText, CountText };
